<section fxLayout="row" class="h-100">
    <section fxFlex="1 1 77%" class="sen-body-max-width" id="inverter_canvas_container">
        <div id="canvasInverter"></div>
    </section>
    <div class="loader" id="displayonImgCal"></div>
    <section fxLayout="column" class="sen-tool-bar sen-light-blue-bg">
        <div fxFlex="1 1 auto" fxLayout="column" class="overflow-hidden">
            <div class="sen-active-main-menu p-2" fxLayout="row" fxLayoutAlign="space-evenly center">
                <img class="sen-cursor-pointer" title="{{translate.getLng('INV_MANUAL_DRAW')}}" id="colorBgForImage"
                    src="{{imagePath.MANUAL_DRAW}}" width="30" (click)="manualDraw()">
                <img class="sen-cursor-pointer" src="{{imagePath.AUTO_DRAW}}"
                    title="{{translate.getLng('INV_AUTO_DRAW')}}" width="30" (click)="autoDrawStrings()">
                <img class="sen-cursor-pointer" src="{{imagePath.REMOVE_PANEL}}"
                    title="{{translate.getLng('INV_REMOVE_STRING')}}" width="30" (click)="clearStrings()">
                <img class="sen-cursor-pointer" src="{{imagePath.PLACE_CENTER}}" width="30"
                    title="{{translate.getLng('INV_ZOOM_FIT')}}" (click)="zoomFit()">
            </div>
            <table class="mx-3 pt-2">
                <tr>
                    <td><label class="text-nowrap">{{translate.getLng('DRAG_MODE')}}</label>&nbsp;
                        <mat-slide-toggle color="primary" [checked]="enableDragLayout" (change)="enableDrag()">
                        </mat-slide-toggle>
                    </td>
                </tr>
            </table>
            <div fxFlex="1 1 auto" class="mx-3 mb-2 overflow-auto">
                <mat-accordion>
                    <mat-expansion-panel *ngFor="let g of selectedInverter.subGenerators; index as i"
                        class="sen-overflow-visible" [expanded]="collapseIndex == i+1">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div class="w-100" fxLayout="row" fxLayoutAlign="space-between center">
                                    <span class="sen-fs12" title="{{g.name}}">{{g.name | truncate: 20}}
                                        ({{g.panelCount}})</span>
                                    <div (click)="triggerGeneratorTool(g)" class="sen-cursor-pointer">
                                        <span class="sen-color-picker ml-2 d-inline-block"
                                            [style.background]="g.color"></span>
                                    </div>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <table class="m-auto sen-fs10 w-100">
                            <tr *ngFor="let s of g.strings; let i = index">
                                <td>
                                    <div fxLayout="row" fxLayoutAlign="flex-start center"
                                        id='{{s.name.replace(" ", "_") }}'>
                                        <mat-icon [style.color]="s.color" class="sen-fs12">timeline</mat-icon>
                                        <span class="gap">{{s.name}}
                                            ({{s.panelCount}})</span>
                                        <mat-icon *ngIf="completedStrLine.indexOf(s.name) != -1"
                                            class="sen-fs12 text-success">
                                            check_circle</mat-icon>
                                    </div>
                                </td>
                                <td align="right"><span
                                        class="sen-color-picker sen-cursor-pointerml-5 border-dark d-block"
                                        (click)="triggerGeneratorTool(s)" [style.background]="s.color"></span>
                                </td>
                            </tr>
                        </table>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
        <table class="mt-3 border-0 w-75 m-auto sen-fs10">
            <tr>
                <td class="p-2 text-white border-bottom border-white sen-active-main-menu">
                    {{translate.getLng('TOTAL_PANELS')}}:</td>
                <td class="p-2 border border-dark border-left-0">{{selectedInverter.panelCount}}</td>
            </tr>
            <tr>
                <td class="p-2 text-white sen-active-main-menu">{{translate.getLng('PANELS_DRAWN')}}:</td>
                <td class="border-bottom border-right border-dark p-2">{{panelDrawn}}</td>
            </tr>
        </table>
        <div class="my-2" fxLayout="row" fxLayoutAlign="space-evenly center">
            <button mat-raised-button class="px-5 py-2" color="primary"
                [routerLink]="[prevPath]">{{translate.getLng('PREV')}}</button>
            <button mat-raised-button class="px-5 py-2" color="primary"
                (click)="goNext()">{{translate.getLng('NEXT')}}</button>
        </div>
    </section>
</section>
